module.exports = __webpack_public_path__ + "media/images/gifts/autonomy/sug_autonomia_6-36dcda8eb784707bedd973b88420fdcc.jpg";